import i18n from '@/plugins/i18n'

export default [
    {
        name: 'Dashboard',
        icon: 'mdi-view-dashboard',
        path: '/',
    },
    {
        name: 'DashboardV2',
        icon: 'mdi-chart-line',
        path: '/v2',
    },
    {
        name: 'DashboardV3',
        icon: 'mdi-chart-line',
        path: '/v3',
    },
    {
        name: 'Partners',
        icon: 'mdi-store',
        path: '/' + i18n.t('partner.routes.index'),
    },
    {
        name: 'Leads',
        icon: 'mdi-briefcase-search',
        path: '/' + i18n.t('routes.lead.index'),
    },
    {
        name: 'Customers',
        icon: 'mdi-account-group',
        path: '/' + i18n.t('customer.routes.index'),
    },
    {
        name: 'Marketing',
        icon: 'mdi-bullhorn',
        children: [
            {
                name: 'Files',
                href: 'https://lps.connectplug.com.br/materiais-parceiros/',
            },
            {
                name: 'Landing Pages',
                path: '/' + i18n.t('routes.landingPage.index'),
            },
        ],
    },
    {
        name: 'Categories',
        icon: 'mdi-seal',
        path: '/' + i18n.t('routes.category.index'),
    },
    {
        name: 'Bills',
        icon: 'mdi-currency-usd',
        path: '/' + i18n.t('routes.bill.index'),
    },
    {
        name: 'Commissions',
        icon: 'mdi-cash',
        children: [
            {
                name: 'commission-partners',
                path: '/commissions',
            },
            {
                name: 'Taxes',
                path: `/${i18n.t('commissions.taxes.routes.index')}`,
            },
            {
                name: 'commission-config',
                path: `/${i18n.t('commissions.configurations.routes.index')}`,
            },
        ],
    },
    {
        name: 'Products',
        icon: 'mdi-cart',
        children: [
            {
                name: 'Products',
                path: '/' + i18n.t('routes.product.index'),
            },
            {
                name: 'Sales',
                path: '/' + i18n.t('routes.productSale.index'),
            },
        ],
    },
    {
        name: 'Reports',
        icon: 'mdi-chart-bar',
        children: [
            {
                name: 'Bills',
                path: '/' + i18n.t('routes.reports.bills'),
            },
            {
                name: 'Bookings',
                path: '/' + i18n.t('routes.reports.bookings'),
            },
            {
                name: 'Resellers',
                path: '/' + i18n.t('routes.reports.resellers'),
            },
        ],
    },
    {
        name: 'Settings',
        icon: 'mdi-cog',
        children: [
            {
                name: 'Plans',
                path: '/' + i18n.t('plans.routes.index'),
            },
            {
                name: 'Plan Packages',
                path: '/' + i18n.t('planPackages.routes.index'),
            },
            {
                name: 'Modules',
                path: '/' + i18n.t('modules.routes.index'),
            },
            {
                name: 'Roles',
                path: '/' + i18n.t('roles.routes.index'),
            },
            {
                name: 'Users',
                path: '/users',
            },
            {
                name: 'Profile',
                path: '/profile',
            },
            {
                name: 'Mails',
                path: '/' + i18n.t('routes.mail.index'),
            },
            {
                name: 'Popups',
                path: '/' + i18n.t('routes.popup.index'),
            },
            {
                name: 'Notifications',
                path: '/' + i18n.t('routes.notifications.index'),
            },
        ],
    },
    {
        name: 'Logs',
        icon: 'mdi-history',
        path: '/logs',
    },
]
